// icons
import {
    BookText,
    Bot,
    FileCog,
    FolderGit2,
    GalleryHorizontalEnd,
    LayoutGrid,
    MessagesSquare,
    MessageSquareCode,
    Users,
    Blocks
} from 'lucide-react';
// utils
import { PATHS } from '@/const';

type NavItem = {
    icon: React.ReactNode;
    path: string;
    label: string;
    idn?: string;
};

const navItems: NavItem[] = [
    {
        icon: <FolderGit2 />,
        path: PATHS.projects,
        label: 'Projects'
    },
    {
        icon: <GalleryHorizontalEnd />,
        path: PATHS.versionControl,
        label: 'Version Control'
    },
    {
        icon: <BookText />,
        path: PATHS.akb,
        label: 'AKB'
    },
    {
        icon: <LayoutGrid />,
        path: PATHS.integrations,
        label: 'Integrations'
    },
    {
        icon: <MessagesSquare />,
        path: PATHS.conversations,
        label: 'Conversations',
        idn: 'conversations'
    },
    {
        icon: <Users />,
        path: PATHS.personas,
        label: 'Personas',
        idn: 'personas'
    },
    {
        icon: <FileCog />,
        path: `${PATHS.attributes.root}/customer`,
        label: 'Attributes'
    },
    {
        icon: <MessageSquareCode />,
        path: PATHS.sessions,
        label: 'Sessions',
        idn: 'sessions'
    },
    {
        icon: <Blocks />,
        path: PATHS.widgets,
        label: 'Workflows'
    },
    {
        icon: <Bot />,
        path: PATHS.vibeBuilder,
        label: 'Vibe Mode',
        idn: 'vibeBuilder'
    }
];

export default navItems;
